// Copyright (c) 2016 Deere & Company

import CreateClaimModal, {getDefaultState} from '../../../../shared/state/create-claim-modal';
import actions from '../action-list';

const resetModalState = state => {

    const createClaimModalState = getDefaultState();

    return CreateClaimModal.update(createClaimModalState, {
        claimTypes: {
            $set: state.claimTypes
        }
    });

};

const updateClaimModalMode = (state, action) =>
    CreateClaimModal.update(state, {
        mode: {
            $set: action.mode
        }
    });

const updateClaimTypes = (state, action) =>
    CreateClaimModal.update(state, {
        claimTypes: {
            $set: action.claimTypes
        }
    });

const updateCreateClaimModalVisibility = (state, action) =>
    CreateClaimModal.update(state, {
        isModalOpen: {
            $set: action.isVisible
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_MASS_CHANNEL_PDI]: resetModalState,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_MODAL_MODE]: updateClaimModalMode,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_CLAIM_TYPES]: updateClaimTypes,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_CREATE_CLAIM_MODAL_VISIBILITY]: updateCreateClaimModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/reducers/create-claim-modal.js